module.exports = __webpack_public_path__ + "static/media/tutorial_atualizado.ab68acb6.pdf";